import { ApiProject, ApiSync } from "@incendium/api";
import { syncService } from "Apis";
import { useProjectSharedState } from "./useSharedState";

const fetchExternalSyncs = async (project: ApiProject) => {
  const res = await syncService.syncServiceListSyncs({
    projectId: project.id as number,
  });
  return res.results || [];
};

export const useExternalSyncs = () => {
  const { state, setState, refetch, loading, fetched } = useProjectSharedState(
    "externalSyncs",
    [],
    fetchExternalSyncs
  );

  return {
    externalSyncs: state as ApiSync[],
    setExternalSyncs: setState,
    refetch,
    loading,
    fetched,
  };
};
